
<div :class="['fork-booking-cont', { 'iframe-mode': isIframe }]">
  <div class="resto-infos">
    <div class="resto-name">{{ getAllInfos.restoName }}</div>
    <div class="resto-coords">
      <div class="resto-adresse">{{ getAllInfos.restoAdresse }}</div>
      <div class="resto-tel"><a :href="'tel:' + getAllInfos.restoTel">{{ getAllInfos.restoTel }}</a></div>
    </div>
  </div>
  <div class="fork-booking">
    <el-button-group class="booking-milestone" v-if="currentStep !== 4">
      <el-button class="milestone-button date" :class="{ 'active': currentStep >= 0, 'arrow': currentStep === 0 }"
        :type="currentStep === 0 ? 'primary' : 'default'" @click="setCurrentStep(0)">
        <div class="button-content">
          <template v-if="!getCurrentDateShorter || currentStep === 0">
            <i class="el-icon-date"></i>
            Date
          </template>
          <template v-else>
            {{ getCurrentDateShorter }}
          </template>
        </div>
      </el-button>

      <el-button class="milestone-button persons" :class="{ 'active': currentStep >= 1, 'arrow': currentStep === 1 }"
        :disabled="currentStep < 1" :type="currentStep === 1 ? 'primary' : 'default'" @click="setCurrentStep(1)">
        <div class="button-content">
          <i class="el-icon-user-solid"></i>
          {{ getNbCouvert && currentStep > 1 ? getNbCouvert : '' }}
        </div>
      </el-button>
      <el-button class="milestone-button hours" :class="{ 'active': currentStep >= 2, 'arrow': currentStep === 2 }"
        :disabled="currentStep < 2" :type="currentStep === 2 ? 'primary' : 'default'" @click="setCurrentStep(2)">
        <template v-if="!selectedService || currentStep === 2">
          <i class="el-icon-time"></i>
        </template>
        <template v-else>
          <div class="button-content">
            {{ selectedService.hour }}
          </div>
        </template>
      </el-button>
      <el-button class="milestone-button form last" :class="{ 'active': currentStep === 3 }"
        :disabled="currentStep < 3" :type="currentStep === 3 ? 'primary' : 'default'" @click="setCurrentStep(3)">
        <div class="button-content">
          <i class="el-icon-edit"></i>
        </div>
      </el-button>
    </el-button-group>
    <el-divider class="divider mt mb" v-if="currentStep === 1 || currentStep === 2 || currentStep === 4" />

    <h2 v-if="currentStep === 1" class="text-help"><i class="el-icon-user-solid"></i>Nombre de personnes</h2>
    <h2 v-if="currentStep === 2" class="text-help"><i class="el-icon-time"></i>Heure de réservation</h2>
    <h2 v-if="currentStep === 4" class="text-help"><i class="el-icon-circle-check"></i>Confirmation</h2>

    <el-divider class="divider mt" />

    <calendar-custom v-if="currentStep === 0" :checkVisibility="true" />
    <persons-selection v-if="currentStep === 1" />
    <hours-selection v-if="currentStep === 2" />
    <form-fork-booking v-if="currentStep === 3" />
    <confirm-fork-booking v-if="currentStep === 4" />
  </div>
  <div class="powered">
    <a href="https://resa.ninja" target="_blank">
      <span>powered by</span>
      <p>Resa.Ninja</p>
    </a>
  </div>
</div>
